
// Submit form with external button
var submitForm = function(form, action) {
    if (typeof(action) !== 'undefined') {
        // Fill redirectoption if user wants to save & close the form
        $('#redirectoption').val(action);
    }

    // Submit form
    $(form).submit();
};

window.submitForm = submitForm;

$(function(){
    $('#user_email').change(function(){
        var user_email = $('#user_email').val();
        $('#username').val(user_email);
    });
});

var pdfLinkWorkorder = $("#pdf-link-workorder");
pdfLinkWorkorder.click(function (e) {
    if (e.target.target === '_system') {
        e.preventDefault();
        parent.postMessage(JSON.stringify({
            type: "open",
            data: e.target.href,
        }), '*');
        return false;
    }
});



// WEBPACK FOOTER //
// ./resources/js/components/forms.js